<template>
  <v-row>
    <v-dialog v-model="show" max-width="800px" persistent>
      <v-card v-if="customForm">
        <v-card-title v-if="!isNew" mt-2 style="justify-content: center;">{{ $t('custom.update') }}</v-card-title>
        <v-card-title v-else mt-2 style="justify-content: center;">{{ $t('custom.new') }}</v-card-title>
        <v-card-text>
          <validation-observer ref="form">
            <v-form >
              <validation-provider v-slot="{ errors }" :name="$t('custom.customFieldName')" rules="required">
                <v-col cols="12">
                  <v-text-field
                      v-model="customForm.name"
                      :error-messages="errors"
                      :label="$t('custom.customFieldName')"
                      class="required"
                      clearable
                      required
                  >
                  </v-text-field>
                </v-col>
              </validation-provider>

              <validation-provider v-slot="{ errors }" :name="$t('custom.customFieldValue')" rules="required">
                <v-col cols="12">
                  <v-text-field
                      v-model="customForm.value"
                      :error-messages="errors"
                      :label="$t('custom.customFieldValue')"
                      class="required"
                      clearable
                      required
                  >
                  </v-text-field>
                </v-col>
              </validation-provider>
            </v-form>
          </validation-observer>
        </v-card-text>
        <v-card-actions class="pa-0 mt-2">
          <v-btn
              color="primary"
              style="width: 50%"
              tile
              @click="onSubmit()"
          >
            {{ $t('custom.validate') }}
          </v-btn>
          <v-btn
              class="ml-0"
              color="secondary"
              style="width: 50%"
              tile
              @click="close()">
            {{ $t('custom.cancel') }}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-row>

</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'CustomForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    custom: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
      default: false
    },
    isNew: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      customForm : null
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  mounted () {
    this.customForm = Object.assign({}, this.custom)
  },
  methods: {
    close () {
      this.$refs.form.reset()
      this.$emit('close')
    },
    async onSubmit () {
      const success =  await this.$refs.form.validate()
      if(success){
        this.$emit('validate', this.customForm)
        this.close()
      }
    }
  }
}
</script>
